import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getCharacters,
  purchaseCharacter,
  setCharacterToMain,
} from "../../Services/Requests.ts";
import useApplicationSettings from "../../Store/ApplicationSettings.js";
import durabilityIcon from "../../../assets/Icons/shopComponent/durability.svg";
import earnsIcon from "../../../assets/Icons/shopComponent/earns.svg";
import starIcon from "../../../assets/Icons/shopComponent/star.svg";
import basketIcon from "../../../assets/Icons/shopComponent/Shopping-Cart.svg";
import setMainIcon from "../../../assets/Icons/shopComponent/to-main-screen.svg";
import infiniteDurabilityIcon from "../../../assets/Icons/shopComponent/infinity-svgrepo-com.svg";
import "./Shop.css"; // Убедитесь, что создали этот файл для стилей
import useUserStore from "../../Store/UserStore.js";
import CharacterPurchaseModal from "./components/CharacterPurchaseModal.jsx";
import { useNotificationStore } from "../../Store/NotificationStore.ts";

const rarityTranslations = {
  Common: "Обычный",
  Uncommon: "Необычный",
  Rare: "Редкий",
  Epic: "Эпический",
  Legendary: "Легендарный",
  Default: "Стандартный",
  Special: "Особый",
};

// Компонент для карточки доступного персонажа
const AvailableCharacterCard = ({ character, balance, onPurchase }) => {
  // Вычисляем общую доходность
  const totalEarnings =
    character.durability === -1
      ? character.earns_dreamcoin // Используем earns_dreamcoin, если durability -1
      : character.durability * character.earns_usdt;

  return (
    <div key={character.slug} className="character-card">
      <div className="rarity-badge">
        <span className="star-icon">
          <img src={starIcon} alt="Star" />
        </span>
        {rarityTranslations[character.rarity]}
      </div>
      <img className="character-bg-icon" src={character.icon_url} alt="" />
      <div className="character-info">
        <div className="stat">
          <span className="stat-icon">
            <img src={durabilityIcon} alt="Durability" />
          </span>
          <span className="stat-label">Прочность</span>
          <span
            className={
              character.durability === -1 ? "infinite-durability" : "stat-value"
            }
          >
            {character.durability === -1 ? "∞" : character.durability}
          </span>
        </div>
        <div className="stat">
          <span className="stat-icon">
            <img src={earnsIcon} alt="Earns" />
          </span>
          <span className="stat-label">Доходность</span>
          <span className="stat-value">$ {totalEarnings.toFixed(2)}</span>
        </div>
        {!character.is_purchased && (
          <button
            className={`buy-btn ${balance < character.price ? "disabled" : ""}`}
            onClick={() => onPurchase(character)}
          >
            <img src={basketIcon} alt="Buy" />
            {character.price} DC
          </button>
        )}
      </div>
    </div>
  );
};

// Компонент для карточки owned персонажа
const OwnedCharacterCard = ({ characterData, onSetMain }) => {
  const character = characterData.character;
  const durabilityLeft = characterData.durability_left;
  const isActive = characterData.is_active;

  // Вычисляем общую доходность
  const totalEarnings =
    character.durability === -1
      ? character.earns_dreamcoin // Используем earns_dreamcoin, если durability -1
      : character.durability * character.earns_usdt;

  let earnedAmount;
  // Вычисляем уже заработанное
  if (character.durability === -1) {
    if (character.rarity === "Default") {
      earnedAmount = `DC ${Number(character.earns_dreamcoin).toFixed(2)}`;
    } else {
      earnedAmount = `$ ${Number(character.earns_usdt).toFixed(4)}`;
    }
  } else {
    earnedAmount = `$ ${Number(
      (character.durability - durabilityLeft) * character.earns_usdt
    ).toFixed(4)}`;
  }

  return (
    <div
      key={character.slug}
      className={`character-card owned ${isActive ? "active" : ""}`}
    >
      <div className="rarity-badge">
        <span className="star-icon">
          <img src={starIcon} alt="Star" />
        </span>
        {rarityTranslations[character.rarity]}
      </div>
      <img className="character-bg-icon" src={character.icon_url} alt="" />
      <div className="character-info-owned">
        <div className="stat durability-stat-owned">
          <div className="durability-info-owned">
            <span className="durability-value-owned">
              <span className="stat-icon-owned">
                <img src={durabilityIcon} alt="Durability" />
              </span>
              <span
                className={
                  character.durability === -1
                    ? "infinite-durability"
                    : "durability-text-owned"
                }
              >
                {character.durability === -1 ? (
                  <img src={infiniteDurabilityIcon} alt="Infinite Durability" />
                ) : (
                  `${durabilityLeft}/${character.durability}`
                )}
              </span>
            </span>
            <span className="durability-label-owned">Текущая прочность</span>
          </div>
          <button
            className={`set-main-btn ${isActive ? "active" : ""}`}
            onClick={() => !isActive && onSetMain(character.id)}
          >
            <img src={setMainIcon} alt="Set Main" />
          </button>
        </div>
        <div className="stat earns-stat-owned">
          <span className="stat-icon">
            <img src={earnsIcon} alt="Earns" />
          </span>
          <span className="stat-label">
            {character.durability === -1 ? "Доходность" : "Заработано"}
          </span>
          <span className="stat-value">{earnedAmount}</span>
        </div>
      </div>
    </div>
  );
};

export default function Shop() {
  const [availableCharacters, setAvailableCharacters] = useState([]);
  const [ownedCharacters, setOwnedCharacters] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [filter, setFilter] = useState("Все");
  const [showOwned, setShowOwned] = useState(false);
  const navigate = useNavigate();
  const setShowMenubar = useApplicationSettings(
    (state) => state.setShowMenubar
  );

  const localization = useApplicationSettings((state) => state.localization);
  const balanceDC = useUserStore((state) => state.balanceDC);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalClosing, setIsModalClosing] = useState(false);
  const [selectedCharacter, setSelectedCharacter] = useState(null);

  const setNotification = useNotificationStore(
    (state) => state.setNotification
  );

  const tg = window.Telegram.WebApp;

  useEffect(() => {
    setShowMenubar(true);
    document.body.style.overflowY = "hidden";
    setLoading(true);
    getCharacters((data) => {
      if (
        data &&
        Array.isArray(data.owned_characters) &&
        Array.isArray(data.available_characters)
      ) {
        setAvailableCharacters(data.available_characters);
        setOwnedCharacters(data.owned_characters);
      } else {
        console.error("Неверный формат данных:", data);
        setError("Ошибка при получении данных о персонажах.");
      }
      setLoading(false);
    });

    return () => {
      if (tg && tg.BackButton) {
        tg.BackButton.offClick();
      }
      document.body.style.overflowY = "auto";
    };
  }, []);

  const filteredCharacters = showOwned
    ? ownedCharacters.filter(
        (char) =>
          filter === "Все" ||
          rarityTranslations[char.character.rarity] === filter
      )
    : availableCharacters
        .filter(
          (char) => filter === "Все" || rarityTranslations[char.rarity] === filter
        )
        .sort((a, b) => {
          if (filter === "Все") {
            return a.price - b.price;
          }
          return 0;
        });

  const handlePurchaseClick = (character) => {
    if (balanceDC < character.price) {
      return;
    }
    setSelectedCharacter(character);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalClosing(true);
    setTimeout(() => {
      setIsModalOpen(false);
      setIsModalClosing(false);
      setSelectedCharacter(null);
    }, 300);
  };

  const handleConfirmPurchase = () => {
    if (selectedCharacter) {
      handlePurchase(selectedCharacter);
      handleCloseModal();
    }
  };

  const handlePurchase = (character) => {
    if (balanceDC < character.price) {
      return;
    }

    const characterId = character.id;

    purchaseCharacter(characterId, (response) => {
      if (response.status === 200 && response.data) {
        // Обновляем оба списка из ответа сервера
        if (Array.isArray(response.data.available_characters)) {
          setAvailableCharacters(response.data.available_characters);
        }

        if (Array.isArray(response.data.owned_characters)) {
          setOwnedCharacters(response.data.owned_characters);
        }

        // Обновляем баланс
        const newBalance = balanceDC - character.price;
        useUserStore.getState().setBalanceDC(newBalance);
      }
    });
  };

  const handleSetMain = (characterId) => {
    // Сначала обновляем локально
    setOwnedCharacters((prevCharacters) =>
      prevCharacters.map((char) => ({
        ...char,
        is_active: char.character.id === characterId, // true для выбранного, false для остальных
      }))
    );

    // Затем отправляем запрос на сервер
    setCharacterToMain(characterId, (response) => {
      if (response === null) {
          console.error("Ошибка при установке персонажа на сервере.");
      }
    });
  };

  const handleTabChange = (isOwned) => {
    setShowOwned(isOwned);
    // Сбрасываем фильтр при переключении на вкладку "Мои"
    if (isOwned) {
      setFilter("Все");
    }
  };

  if (loading) return <div className="loading">Загрузка персонажей...</div>;
  if (error) return <div className="error">Ошибка: {error}</div>;

  return (
    <div className="shop-container">
      <div className="shop-header">
        <div className="tabs">
          <span
            className={`tab ${!showOwned ? "active" : ""}`}
            onClick={() => handleTabChange(false)}
          >
            Магазин
          </span>
          <span
            className={`tab ${showOwned ? "active" : ""}`}
            onClick={() => handleTabChange(true)}
          >
            Мои
          </span>
        </div>
      </div>
      {!showOwned && (
        <div className="filter-buttons">
          {[
            "Все",
            "Обычный",
            "Необычный",
            "Редкий",
            "Эпический",
            "Легендарный",
          ].map((rarity) => (
            <button
              key={rarity}
              className={`filter-btn ${filter === rarity ? "active" : ""}`}
              onClick={() => setFilter(rarity)}
            >
              {rarity}
            </button>
          ))}
        </div>
      )}
      <div className="character-grid-wrapper">
        <div className="character-grid">
          {filteredCharacters.map((item) => {
            if (showOwned) {
              return (
                <OwnedCharacterCard
                  key={item.character.slug}
                  characterData={item}
                  onSetMain={handleSetMain}
                />
              );
            } else {
              return (
                <AvailableCharacterCard
                  key={item.slug}
                  character={item}
                  balance={balanceDC}
                  onPurchase={handlePurchaseClick}
                />
              );
            }
          })}
        </div>
      </div>
      <CharacterPurchaseModal
        isOpen={isModalOpen}
        isClosing={isModalClosing}
        onClose={handleCloseModal}
        onConfirm={handleConfirmPurchase}
        character={selectedCharacter}
      />
    </div>
  );
}
